import script from "./ListOfDepots.vue?vue&type=script&setup=true&lang=js"
export * from "./ListOfDepots.vue?vue&type=script&setup=true&lang=js"

import "./ListOfDepots.vue?vue&type=style&index=0&id=ebb0038e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebb0038e"]])

export default __exports__